import { useCityStore } from '~/store/city/city'

import { Success } from '~/api/results'
import { Seo } from '~/types/main'

export const useSales = async (showArchived?: boolean) => {
  const {
    cityInfo: { padeg },
  } = useCityStore()

  const { pending, data: salesData } = await useAsyncData(async (nuxtApp) => {
    const result = await nuxtApp?.$apiService.sales.fetchSales()

    if (!result || result instanceof Error) return

    if (result instanceof Success) return result.data
  })

  const seoTitle = ref('')
  const seoDescription = ref('')
  const seoKeywords = ref('')

  // SEO для акций
  if (!showArchived) {
    seoTitle.value = salesData.value?.seo?.seo_title || ''
    seoDescription.value = salesData.value?.seo?.seo_description || ''
    seoKeywords.value = salesData.value?.seo?.seo_keywords || ''
  } else {
    // SEO для АРХИВНЫХ акций
    seoTitle.value = `Завершенные акции на пиццу и суши — ресторан Farfor в ${
      padeg?.pred ?? ''
    }`
    seoDescription.value = `Завершенные акционные предложения от ресторана Фарфор в ${
      padeg?.pred ?? ''
    } ✅ Следите за актуальными новостями и оформите заказ по выгодной цене уже сейчас ➥ Звони или оставляй заявку через сайт!`
    seoKeywords.value = 'акции скидки суши пицца фарфор ресторан доставка'
  }

  const seo: Seo = {
    title: seoTitle.value,
    description: seoDescription.value,
    keywords: seoKeywords.value,
  }

  const headerText = computed(() =>
    showArchived ? 'Завершенные акции' : 'Акции',
  )
  const sales = computed(() =>
    showArchived
      ? salesData.value?.promotions?.filter((sale) => sale.archive)
      : salesData.value?.promotions?.filter((sale) => !sale.archive),
  )

  const breadcrumbs = computed(() => {
    const breadcrumbs = [
      { text: `Доставка суши в ${padeg?.pred}`, href: '/' },
      { text: 'Акции', href: '/sales/' },
    ]

    if (showArchived)
      breadcrumbs.push({ text: headerText.value, href: '/sales/archive/' })

    return breadcrumbs
  })

  const additionalInfo = salesData.value?.additional_info

  return {
    pending,
    breadcrumbs,
    sales,
    headerText,
    seo,
    additionalInfo,
  }
}
